import { UI_PRIMITIVE__card_header } from '@/components/ui/card/card';
import { UI_PTIMITIVE__card } from '@/components/ui/card/UI_PTIMITIVE__card';
import { ENUM__page_type } from '@/enums/ENUM__page_type';
import { use_dispatch } from '@/hooks/_base/use_dispatch';
import { use_effect } from '@/hooks/_base/use_effect';
import { use_slice_ui } from '@/hooks/store/use_slices';
import i18n_errors from '@/locales/keys/i18n_errors.json';
import i18n_page_auth from '@/locales/keys/i18n_page_auth.json';
import { ENUM__i18n_namespace } from '@/services/i18n/ENUM__i18n_namespace';
import { remote_user_auth_login_with_magic_link_token } from '@/state/user/auth/login/remote_user_auth_login_with_magic_link_token';
import { LOCAL__workspace_set_is_all_data_loaded } from '@/state/workspace/entity/LOCAL__workspace_set_is_all_data_loaded';
import { DTO_RESPONSE__auth_success } from '@shared/dto/+user/auth/_requests/response_auth_success';
import { DTO_RESPONSE__error } from '@shared/network/DTO_RESPONSE__error';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate, useParams } from 'react-router-dom';
import { LayoutMobile } from '../../layouts/LayoutMobile';
import { LAYOUT_PAGE__recent_images_grid } from '../_base/layouts/LAYOUT_PAGE__recent_images_grid';
import { ButtonOpenPageAuth } from '../page_auth/buttons/ButtonOpenPageAuth';

export function PAGE__auth_with_magic_link() {
  const dispatch = use_dispatch();
  const navigate = useNavigate();

  let { token_magic_link } = useParams();

  const { t } = useTranslation(ENUM__i18n_namespace.PAGE_AUTH);

  const { global_is_mobile } = use_slice_ui(['global_is_mobile']);

  let [error, setError] = useState('');

  /*
   * EFFECTS
   */
  use_effect(() => void init());

  /*
   * METHODS
   */
  async function init() {
    token_magic_link = token_magic_link || '';

    let action_result = await dispatch(remote_user_auth_login_with_magic_link_token(token_magic_link));

    if (action_result.payload instanceof DTO_RESPONSE__auth_success) return void navigate(ENUM__page_type.MAIN);

    if (action_result.payload instanceof DTO_RESPONSE__error) {
      setError(action_result.payload.type);
    }

    dispatch(LOCAL__workspace_set_is_all_data_loaded(true));
  }

  /*
   * RENDERS
   */

  function render_error() {
    if (!error) return <></>;

    console.log(error);

    return (
      <>
        <span className="text-lg">{t(i18n_page_auth.auth_with_magic_link.title.main)}</span>
        <span>{t(i18n_errors.all_errors[error], { ns: ENUM__i18n_namespace.ERRORS })}</span>
        <ButtonOpenPageAuth />
      </>
    );
  }

  function render_view_with_error() {
    let out = <></>;

    if (!error) return out;

    if (global_is_mobile) {
      out = (
        <LayoutMobile>
          <div className="px-16  pb-8  flex flex-col w-full h-full  justify-center items-center gap-10">{render_error()}</div>
        </LayoutMobile>
      );
    } else {
      out = (
        <LAYOUT_PAGE__recent_images_grid>
          <UI_PTIMITIVE__card className="w-[23rem] h-[20.75rem] bg-component border-component-border flex  justify-center items-center ">
            <UI_PRIMITIVE__card_header className="px-16 pt-6 pb-8  flex  justify-center items-center gap-10">{render_error()}</UI_PRIMITIVE__card_header>
          </UI_PTIMITIVE__card>
        </LAYOUT_PAGE__recent_images_grid>
      );
    }

    return out;
  }

  /*
   * METHODS
   */
  return render_view_with_error();
}
